export default "__VITE_ASSET__CiriYmTj__"